// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as StyleConstants$LiveRoom from "../styles/StyleConstants.bs.js";

function evaluateBreakpoint(param) {
  var w = window.innerWidth;
  if (w > StyleConstants$LiveRoom.Breakpoint.desktopWidth) {
    return /* Desktop */0;
  } else if (w > StyleConstants$LiveRoom.Breakpoint.tabletPortraitWidth) {
    return /* DesktopAndTabletLandscape */4;
  } else if (w > StyleConstants$LiveRoom.Breakpoint.mobileWidth) {
    return /* TabletPortraitAndMobile */2;
  } else {
    return /* Mobile */1;
  }
}

function useBreakpoint(param) {
  var match = React.useState(function () {
        return evaluateBreakpoint(undefined);
      });
  var setBreakpoint = match[1];
  React.useEffect((function () {
          var resizeEvent = function (_e) {
            Curry._1(setBreakpoint, (function (param) {
                    return evaluateBreakpoint(undefined);
                  }));
          };
          window.addEventListener("resize", resizeEvent);
          return (function (param) {
                    window.removeEventListener("resize", resizeEvent);
                  });
        }), []);
  return match[0];
}

export {
  evaluateBreakpoint ,
  useBreakpoint ,
}
/* react Not a pure module */
